module.exports = __webpack_public_path__ + "static/media/hamburger.86f47307.svg";